import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { useGameDetailsQuery, usePicksQuery } from "./data.ts";

/**
 * Redirects the user if the game is finished.
 *
 * If the user has made picks for the finished game, redirect them to play the
 * game.
 *
 * Otherwise, if the game is finished and the user has not made picks, redirect
 * them to the splash page.
 */
export function useRedirectIfGameFinished() {
  const navigate = useNavigate();
  const { gameId = "" } = useParams<{ gameId: string }>();

  const gameDetailsQuery = useGameDetailsQuery(gameId);
  const picksQuery = usePicksQuery(gameId);

  const game = gameDetailsQuery.data;
  const gameStatus = game?.status;
  const hasPicks = picksQuery.isSuccess ? picksQuery.data.length > 0 : false;

  useEffect(() => {
    if (gameStatus !== "finished") {
      return;
    }

    if (hasPicks) {
      navigate(`/games/${gameId}/play`, { replace: true });
    } else {
      navigate("/games", { replace: true });
    }
  }, [gameId, gameStatus, hasPicks, navigate]);
}
